import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import Hero from "@/pages/home/components/Hero";
import CategorySection from "@/pages/home/components/CategorySection";
import AboutSection from "@/pages/home/components/AboutSection";
import GuideSection from "@/pages/home/components/GuideSection";
import HowItWorks from "@/pages/home/components/HowItWorks";
import FaqSection from "@/pages/home/components/FaqSection";
import FinalCta from "@/pages/home/components/FinalCta";

const SITE_ORIGIN = (import.meta.env.VITE_SITE_URL || "https://basetaosheet.buzz").replace(/\/+$/, "");
const SITE_LOGO = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Basetao Sheet",
    url: `${SITE_ORIGIN}/`,
    inLanguage: ["en", "fr", "de", "es", "pt"],
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Basetao Sheet",
    url: `${SITE_ORIGIN}/`,
    logo: SITE_LOGO,
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <AboutSection />
        <GuideSection />
        <HowItWorks />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}